export default "__VITE_ASSET__UmmGnnCF__"